import { render, staticRenderFns } from "./PropCommentsTotal.vue?vue&type=template&id=13975272&"
import script from "./PropCommentsTotal.vue?vue&type=script&lang=js&"
export * from "./PropCommentsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports